import devApp from './appdev.js';
import prodApp from './app.js';

const App = process.env.NODE_ENV == 'development' ? devApp : prodApp;

export default App;



// WEBPACK FOOTER //
// ../q-cars/src/index.js